<template>
  <WdsModal sm :show="show" :title="$t('Are you sure?')" @cancel="cancelHandler">
    <template #header>
      <CustomFieldModalHeader :applies-to="appliesTo" />
    </template>
    <WdsAlert v-if="errorBannerMessage" error class="tw-mb-5">
      {{ errorBannerMessage }}
    </WdsAlert>

    {{ cautionText }}

    <template #footer>
      <div class="tw-flex tw-justify-between">
        <WdsButton secondary @click="cancelHandler">
          {{ $t('Cancel') }}
        </WdsButton>

        <WdsButton primary @click="confirmHandler">
          {{ $t('Yes, delete') }}
        </WdsButton>
      </div>
    </template>
  </WdsModal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { WdsAlert, WdsModal, WdsButton } from '@worksome/wds-components'
import { $t } from '@/composables/translation'
import { CustomField } from '@/components/Fields/dataObjects/CustomField'
import { TypeSupportingCustomFieldValues } from '@/gql/graphql'
import { getCustomFieldCautionText } from '@/components/Fields/utils/CustomFieldUtils'
import CustomFieldModalHeader from '@/components/Fields/CustomFieldModalHeader.vue'


interface Props {
  show: boolean
  field: CustomField
  confirm: (field: CustomField) => void
  cancel: (field: CustomField) => void
  appliesTo: TypeSupportingCustomFieldValues
}

const props = withDefaults(defineProps<Props>(), {
  show: false,
})

const errorBannerMessage = ref(null)

function confirmHandler() {
  props.confirm(props.field)
}

function cancelHandler() {
  props.cancel(props.field)
}

const cautionText = computed(() => getCustomFieldCautionText(props.appliesTo))
</script>
